export enum MapGroup {
  MAP_OFA = 'MAP_OFA',
  MAP_FC = 'MAP_FC',
}